// Transparent malady cutouts (assets/v10/maladies/cut), keyed like MALADY_ART:
// the subtype id, with `tool:subtype` overriding where a subtype id is shared.
import type { ImageSourcePropType } from 'react-native';
import { normalizeMaladyId } from '../olmps/spectrum-tools';

const CUT: Record<string, ImageSourcePropType> = {
  achlys: require('../../assets/v10/maladies/cut/achlys.png'),
  amathia: require('../../assets/v10/maladies/cut/amathia.png'),
  dysastria: require('../../assets/v10/maladies/cut/dysastria.png'),
  adrasteia: require('../../assets/v10/maladies/cut/adrasteia.png'),
  aergia: require('../../assets/v10/maladies/cut/aergia.png'),
  akrasia: require('../../assets/v10/maladies/cut/akrasia.png'),
  amechania: require('../../assets/v10/maladies/cut/amechania.png'),
  apate: require('../../assets/v10/maladies/cut/apate.png'),
  aporia: require('../../assets/v10/maladies/cut/aporia.png'),
  ate: require('../../assets/v10/maladies/cut/ate.png'),
  chaos: require('../../assets/v10/maladies/cut/chaos.png'),
  dysnomia: require('../../assets/v10/maladies/cut/dysnomia.png'),
  akosmia: require('../../assets/v10/maladies/cut/akosmia.png'),
  'nemos:akosmia': require('../../assets/v10/maladies/cut/akosmia.png'),
  homados: require('../../assets/v10/maladies/cut/homados.png'),
  kakia: require('../../assets/v10/maladies/cut/kakia.png'),
  koalemos: require('../../assets/v10/maladies/cut/koalemos.png'),
  lethe: require('../../assets/v10/maladies/cut/lethe.png'),
  oistros: require('../../assets/v10/maladies/cut/oistros.png'),
  oizys: require('../../assets/v10/maladies/cut/oizys.png'),
  oknos: require('../../assets/v10/maladies/cut/oknos.png'),
  phthisis: require('../../assets/v10/maladies/cut/phthisis.png'),
  plane: require('../../assets/v10/maladies/cut/plane.png'),
};

export function maladyCutoutFor(subtypeId: string, toolId?: string): ImageSourcePropType | undefined {
  const id = toolId ? normalizeMaladyId(toolId, subtypeId) : subtypeId;
  return (toolId && CUT[`${toolId}:${id}`]) || CUT[id];
}

/** Full-body standing maladies (scripts/build_malady_fullbodies.py): feet on the
 *  bottom edge, one artifact each — for the PANTHEON podiums. */
const FULL: Record<string, ImageSourcePropType> = {
  achlys: require('../../assets/v10/maladies/full/achlys.png'),
  adrasteia: require('../../assets/v10/maladies/full/adrasteia.png'),
  aergia: require('../../assets/v10/maladies/full/aergia.png'),
  akosmia: require('../../assets/v10/maladies/full/akosmia.png'),
  akrasia: require('../../assets/v10/maladies/full/akrasia.png'),
  amathia: require('../../assets/v10/maladies/full/amathia.png'),
  amechania: require('../../assets/v10/maladies/full/amechania.png'),
  apate: require('../../assets/v10/maladies/full/apate.png'),
  aporia: require('../../assets/v10/maladies/full/aporia.png'),
  ate: require('../../assets/v10/maladies/full/ate.png'),
  chaos: require('../../assets/v10/maladies/full/chaos.png'),
  dysastria: require('../../assets/v10/maladies/full/dysastria.png'),
  dysnomia: require('../../assets/v10/maladies/full/dysnomia.png'),
  homados: require('../../assets/v10/maladies/full/homados.png'),
  kakia: require('../../assets/v10/maladies/full/kakia.png'),
  koalemos: require('../../assets/v10/maladies/full/koalemos.png'),
  lethe: require('../../assets/v10/maladies/full/lethe.png'),
  oistros: require('../../assets/v10/maladies/full/oistros.png'),
  oizys: require('../../assets/v10/maladies/full/oizys.png'),
  oknos: require('../../assets/v10/maladies/full/oknos.png'),
  phthisis: require('../../assets/v10/maladies/full/phthisis.png'),
  plane: require('../../assets/v10/maladies/full/plane.png'),
  'nemos:akosmia': require('../../assets/v10/maladies/full/akosmia.png'),
};

const FULL_SIZE: Record<string, [number, number]> = require('../../assets/v10/maladies/full/sizes.json');

export function maladyFullFor(subtypeId: string, toolId?: string): { src: ImageSourcePropType; aspect: number } | undefined {
  const id = toolId ? normalizeMaladyId(toolId, subtypeId) : subtypeId;
  const src = (toolId && FULL[`${toolId}:${id}`]) || FULL[id];
  if (src) {
    const [w, h] = FULL_SIZE[id] ?? [0.45, 1];
    return { src, aspect: w / h };
  }
  const old = maladyCutoutFor(subtypeId, toolId);
  return old ? { src: old, aspect: 0.75 } : undefined;
}
